module.exports = __webpack_public_path__ + "img/icon-warning-polartlavtrykk-3.a39edfa6.svg";